import React from "react";
import { Link } from "react-router-dom";
import "./DetailsBradcrumeSection.css";

export default function DetailsBradcrumeSection({ Pagename, page1 }) {
  // var BGIMGStyle = {
  //   width: "100%",
  //   height: "160px",
  //   backgroundImage: "url(../images/banner/banner4.jpg)",
  // };
  return (
    <>
      {/* PageBradcrume Start  */}
      <section className="DetailsBradcrumeSection">
        <div className="bradcrumeeOverlay"></div>
        <div className="auto-container" style={{ maxWidth: "1400px" }}>
          <div className="title-outer">
            <h1>{Pagename}</h1>
            <ul
              className="Breadcrumbpagefssg"
              style={{ justifyContent: "left" }}
            >
              <li>
                <Link to="/" className="breadcrumb-box">
                  <i
                    className="fa fa-home breadcrumb-icon"
                    aria-hidden="true"
                  ></i>
                </Link>
              </li>
              {page1 &&
                page1.map((value, index) => (
                  <li key={index}>
                    {value.pagelink ? (
                      <Link
                        to={`/${value.pagelink}`}
                        className="breadcrumb-box"
                      >
                        <i
                          className="fa fa-angle-right breadcrumb-icon"
                          aria-hidden="true"
                        ></i>
                        <span className="breadcrumb-text">{value.name}</span>
                      </Link>
                    ) : (
                      <div className="breadcrumb-box">
                        <i
                          className="fa fa-angle-right breadcrumb-icon"
                          aria-hidden="true"
                        ></i>
                        <span className="breadcrumb-text">{value.name}</span>
                      </div>
                    )}
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </section>
      {/* PageBradcrume  End */}
    </>
  );
}
